//
//Coded by Dense Eclipse
//
//Static Data
//title : project title
//image : image related to project
//link : link to the video
//Job


const projects = [
    {
        "title": "Restoration of Zooni : In conversation with Muzaffar Ali",
        "image": require("../assets/images/zoomi.jpg"),
        "link": "https://www.youtube.com/watch?v=mGfEigAQtDs&ab_channel=AnagramEntertainment",
        "job": "Director of Photography",
    },
    {
        "title": "INTOXICATED - DEEP KALSI x RAP DEMON x AGSY | TUNNEL VISION | KALAMKAAR",
        "image": require("../assets/images/intoxicated.jpg"),
        "link": "https://youtu.be/QU-KoMVv5z0?si=G9eeMpAMHiBKofMG",
        "job": "Director of Photography",
    },
    {
        "title": "Friday Finance Season 2 | Hindustan Times",
        "image": require("../assets/images/friday.jpg"),
        "link": "https://youtube.com/playlist?list=PL9wl9ZX1TMB5js4dsB2pAlm1A0LrqGeyi",
        "job": "2nd Unit Director of Photography & Assistant Cinematographer",
    },
    {
        "title": "Ayaana",
        "image": require("../assets/images/ayaana.jpg"),
        "link": "https://youtu.be/tLBf-iTKOLk",
        "job": "Assistant Cinematographer",
    },
    {
        "title": "Alfaaz | MX Player",
        "image": require("../assets/images/alfaaz.jpg"),
        "link": "https://www.hotstar.com/in/movies/alfaaz/1836060195",
        "job": "Director of Photography",
    },
    {
        "title": "Thoda Sa | Zee Music Company",
        "image": require("../assets/images/thoda.jpg"),
        "link": "https://youtu.be/k0HmFf6INu0",
        "job": "Assistant Cinematographer",
    },
    {
        "title": "Balma | Tamasha Music",
        "image": require("../assets/images/balma.jpg"),
        "link": "https://youtu.be/Wfwt2DjhS08",
        "job": "Assistant Cinematographer",
    },
    {
        "title": "Neighbour's Kitchen | Hindustan Times ",
        "image": require("../assets/images/ht.jpeg"),
        "link": "https://www.youtube.com/watch?v=WLBKYiyG3ng",
        "category": "Web",
        "job": "Assistant Cinematographer",
    },
]

export default projects;